import FormuleProduitComplementaireController from './formule.produit.complementaire.controller';
import FormuleProduitComplementaireTemplate from './formule.produit.complementaire.html';
export default {
	bindings: {
		formule: '=',
		formules: '=',
		rechercheDesPrix: '&',
		isEditMode: '='
	},
	controller: FormuleProduitComplementaireController,
	template: FormuleProduitComplementaireTemplate
	//templateUrl: 'app/common/formules/components/formule-form/creation/formule-produit-complementaire/formule.produit.complementaire.html'
};
